import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45833981&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45833981",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45833981')) {
      api.createRecord('45833981', component.options)
    } else {
      api.reload('45833981', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=45833981&scoped=true", function () {
      api.rerender('45833981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms/smsMessage/index.vue"
export default component.exports